module.exports = __webpack_public_path__ + "static/media/wrl-cota-logo@2x.d5bf1c53.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-cota-logo@2x.png
// module id = 1213
// module chunks = 0